import moment from "moment";
import { useEffect, useRef, useState } from "react";

import ToastUtil from "../../../components/ToastNotification/ToastUtil";
import { config } from "../../../config/index";
import { newFetch, POST } from "../../../helpers/fetch";
import { toWeekDaysArrayFull, toWeekStartDate } from "../../../helpers/moment";
import WeekDaySchedule from "./WeekDaySchedule";

const { API_URL } = config;

const WeekSchedule = ({
  client,
  sites,
  activeWeek,
  activeSite,
  t,
  flag = "",
}) => {
  const token = localStorage.getItem("token");
  const componentMounted = useRef(true);
  const [schedules, setSchedules] = useState([]);
  const [activeSchedules, setActiveSchedules] = useState([]);
  const dateRef = useRef(null);

  const getWeekDaysSites = (day) => {
    return activeSchedules
      .filter((schedule) => schedule.date === day.format("YYYY-MM-DD"))
      .filter((schedule) => schedule.site_id === activeSite)
      .map((item) => item.site)
      .filter((value, index, self) => self.indexOf(value) === index);
  };

  const getWeekDaysShifts = (day) => {
    return activeSchedules
      .filter((schedule) => schedule.date === day.format("YYYY-MM-DD"))
      .filter((schedule) => schedule.site_id === activeSite)
      .map((item) => ({
        shift: item.shift,
        start_time: item.start_time
          ? moment(item.start_time, "HH:mm:ss").format("HH:mm")
          : null,
        end_time: item.end_time
          ? moment(item.end_time, "HH:mm:ss").format("HH:mm")
          : null,
        status: item.status,
        status_name: item.status_name,
        time_in: item.time_in
          ? moment(item.time_in, "YYYY-MM-DD HH:mm").format("HH:mm")
          : null,
        time_out: item.time_out
          ? moment(item.time_out, "YYYY-MM-DD HH:mm").format("HH:mm")
          : null,
        total_overtime: item.total_overtime || 0,
        is_undertime: item.is_undertime,
        leave_type: item.leave_type,
      }))
      .filter((value, index, self) => self.indexOf(value) === index);
  };

  const getWeekSchedule = (flag) => {
    if (activeWeek.startDate && client) {
      return toWeekDaysArrayFull(activeWeek.startDate, client.start_day).map(
        (day, index) => (
          <WeekDaySchedule
            key={index}
            day={day}
            getWeekDaysSites={getWeekDaysSites}
            getWeekDaysShifts={getWeekDaysShifts}
            activeSite={activeSite}
            sites={sites}
            t={t}
            flag={flag}
          />
        )
      );
    }
  };

  const fetchSchedule = async () => {
    try {
      await newFetch(
        POST,
        `/associate/site/${activeSite}/assign_fixed_sched_date`,
        {
          start_date: moment(activeWeek.startDate).format("YYYY-MM-DD"),
          end_date: moment(activeWeek.endDate).format("YYYY-MM-DD"),
        }
      );

      let url = `${API_URL}/associate/myschedulebyweek`;
      let response = await fetch(url, {
        mode: "cors",
        method: "POST",
        withCredentials: true,
        body: JSON.stringify({
          start_date: moment(activeWeek.startDate).format("YYYY-MM-DD"),
          end_date: moment(activeWeek.endDate).format("YYYY-MM-DD"),
          site_id: activeSite,
        }),
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json; charset=utf-8",
        },
      });

      if (componentMounted.current) {
        let data = await response.json();
        data.success ? setSchedules(data.data) : ToastUtil.error(data.message);
      }
    } catch (error) {
      console.log("error", error);
      ToastUtil.error(error);
    }
  };

  const filteredSites = () => sites.filter((item) => item.id === activeSite);

  useEffect(() => {
    // fetchSchedule();
    return () => {
      // This code runs when component is unmounted
      componentMounted.current = false; // set it to false when we leave the page
    };
  }, [token]);

  useEffect(() => {
    const fetchSiteSchedules = async () => {
      const currentWeekStartDate = toWeekStartDate(moment(), client.start_day);
      const selectedSite = filteredSites();

      if (
        selectedSite &&
        selectedSite[0]?.enable_br_upload === false &&
        moment(activeWeek.startDate).isSameOrAfter(moment(currentWeekStartDate))
      ) {
        if (
          dateRef.current !== moment(activeWeek.startDate).format("YYYY-MM-DD")
        ) {
          dateRef.current = moment(activeWeek.startDate).format("YYYY-MM-DD");
          const api_path = `/site/${activeSite}/schedule/create`;
          const resp = await newFetch(POST, api_path, {
            start_date: moment(activeWeek.startDate).format("YYYY-MM-DD"),
            end_date: moment(activeWeek.endDate).format("YYYY-MM-DD"),
          });

          if (resp.success) {
            fetchSchedule();
          }
        }
      }
    };

    if (activeWeek.startDate && client) {
      let filtered = schedules.filter((schedule) => {
        return (
          moment(schedule.date, "YYYY-MM-DD") >= moment(activeWeek.startDate) &&
          moment(schedule.date, "YYYY-MM-DD") <= moment(activeWeek.endDate)
        );
      });
      if (filtered.length === 0) {
        fetchSiteSchedules();
      }
      setActiveSchedules(filtered);
    }
  }, [activeWeek, schedules, client]);

  useEffect(() => {
    if (activeWeek.startDate && client) {
      fetchSchedule();
    }
  }, [activeWeek]);

  return (
    <div className="dashboard__weekschedule-container">
      <div className="dashboard__weekschedule-label">
        <label style={{ width: "20%" }}>{t("Time")}</label>
        <label>{t("Location")}</label>
      </div>
      {getWeekSchedule(flag)}
    </div>
  );
};
export default WeekSchedule;
